<div class="p-a-10 p-r-12 p-a-5-s p-a-5-m b-a b-col-5 b-radius-4 height-100">
    <span class="float-right p1 m-l">
        @if (sectionCtaLink) {
        <a class="link"
           [routerLink]="sectionCtaLink">
            {{sectionCta}}
        </a>
        }
        <ng-content select="[section2cta]"></ng-content>
    </span>

    @switch (!!sectionIcon) {
    @case (true) {
    <icon-label [icon]="sectionIcon"
                [textClass]="'s1'">{{ sectionTitle }}</icon-label>
    }
    @case (false) {
    <p class="s1">{{sectionTitle}}</p>
    }
    }


    @if (sectionSubtitle) {
    <p class="p1 col-12">{{sectionSubtitle}}</p>
    }
    <div class="m-t-5">
        <ng-content></ng-content>
        <ng-content select="[section2content]"></ng-content>
    </div>
</div>
